import { render } from "./CheckboxField.vue?vue&type=template&id=9cdb6990"
import script from "./CheckboxField.vue?vue&type=script&lang=js"
export * from "./CheckboxField.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__